import { useTranslation } from "react-i18next";
import { Button, EmptyState } from "@core/components";

/**
 * Step 2, « Éligibilité » (Figma "Appel draft, step 2"): for now only its empty state, « Aucune
 * éligibilité pour l'instant », with « Importer depuis la banque » and a disabled « Enregistrer ».
 * What the step does (import questions, flag every answer) is the next workflow; the two buttons are
 * disabled until then so that nothing on the screen does nothing.
 */
export function EligibilityScreen() {
  const { t } = useTranslation("appels");

  return (
    <div className="flex flex-col gap-lg">
      <EmptyState
        illustration="empty"
        title={t("eligibility.empty")}
        className="min-h-75 justify-center"
        action={<Button isDisabled>{t("eligibility.import")}</Button>}
      />
      <div className="flex justify-end">
        <Button isDisabled>{t("eligibility.save")}</Button>
      </div>
    </div>
  );
}
